import * as colors from '@giphy/colors'
import { StoryPreview } from '@giphy/react-giphy-brand'
import { take } from 'lodash'
import { PureComponent } from 'react'
import { withStorageContext } from 'react-storage-context'
import { SectionHeader } from 'shared/components/text-elements'
import styled from 'styled-components'

const Container = styled.div`
    border-top: 1px solid ${colors.giphyDarkGrey};
    padding-top: 30px;
`

const Header = styled(SectionHeader)`
    color: ${colors.giphyLightGrey};
    margin-bottom: 16px;
`

const Preview = styled.a`
    display: block;
    margin-bottom: 16px;
`

@withStorageContext
export default class MoreStories extends PureComponent {
    render() {
        const { stories } = this.props
        return (
            <Container>
                <Header>More Stories</Header>
                {take(stories, 3).map((story, i) => (
                    <Preview key={i} href={`/stories/${story.slug}`}>
                        <StoryPreview
                            story={story}
                            hideAvatar={true}
                            height={112}
                            width={208}
                            numberOfLines={3}
                            hasWatched={false}
                        />
                    </Preview>
                ))}
            </Container>
        )
    }
}
